export const BRAND_MARK_SRC = '/brand/ristodaily-mark-continuous-gradient-v3-512.png';

export function BrandLogo({ className = '' }) {
  return <BrandWordmark className={`brand-logo ${className}`} />;
}

export function BrandWordmark({ className = '' }) {
  return <span className={`rd-wordmark ${className}`.trim()} role="img" aria-label="RistoDaily"><span className="rd-wordmark-mark" aria-hidden="true" style={{ '--rd-mark-mask': `url("${BRAND_MARK_SRC}")` }} /><span className="rd-wordmark-text" aria-hidden="true">istoDaily</span></span>;
}

export function BrandMark({ className = '' }) {
  return (
    <img
      className={`brand-mark ${className}`.trim()}
      src="/brand/ristodaily-app-v4-192.png"
      width="512"
      height="512"
      alt=""
      aria-hidden="true"
    />
  );
}
